import { fmt } from "@/lib/api";

const Row = ({ label, value, bold, gold }) => (
  <div className={`flex justify-between text-sm py-1 ${bold ? "font-bold text-base" : "text-gray-600"} ${gold ? "text-[#c19a6b] font-semibold" : ""}`}>
    <span>{label}</span>
    <span>{value}</span>
  </div>
);

export const PaymentSection = ({ pkg, paymentOption, setPaymentOption, onReserve, reserving, pickupDate, changeMode }) => {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="grid sm:grid-cols-2 gap-4 mb-8">
        <button
          data-testid="payment-option-deposit"
          onClick={() => setPaymentOption("deposit")}
          className={`text-left p-6 transition-colors duration-200 ${
            paymentOption === "deposit" ? "border-2 border-black bg-white" : "border border-gray-200 bg-white/60 hover:border-gray-400"
          }`}
        >
          <p className="text-[11px] uppercase tracking-[0.18em] font-bold mb-1">Reserve With 50% Deposit</p>
          <p className="font-display text-3xl mt-2">{fmt(pkg.deposit_cents)}</p>
          <p className="text-xs text-gray-500 mt-1">today · remaining {fmt(pkg.balance_cents)} on the invoice schedule</p>
        </button>
        <button
          data-testid="payment-option-full"
          onClick={() => setPaymentOption("full")}
          className={`relative text-left p-6 transition-colors duration-200 ${
            paymentOption === "full" ? "border-2 border-[#c19a6b] bg-white" : "border border-gray-200 bg-white/60 hover:border-gray-400"
          }`}
        >
          <span className="absolute -top-3 left-5 bg-[#c19a6b] text-white text-[10px] tracking-[0.2em] uppercase font-bold py-1 px-3">
            Save {fmt(pkg.discount_cents)}
          </span>
          <p className="text-[11px] uppercase tracking-[0.18em] font-bold mb-1">Pay in Full & Save 10%</p>
          <p className="font-display text-3xl mt-2">{fmt(pkg.discounted_total_cents)}</p>
          <p className="text-xs text-gray-500 mt-1">one payment · 10% off before HST</p>
        </button>
      </div>

      <div className="bg-white border border-gray-200 p-7" data-testid="payment-breakdown">
        {paymentOption === "deposit" ? (
          <>
            <Row label="Subtotal" value={fmt(pkg.subtotal_cents)} />
            <Row label="HST (13%)" value={fmt(pkg.hst_cents)} />
            <div className="border-t border-gray-200 my-2" />
            <Row label="Total" value={fmt(pkg.total_cents)} bold />
            <div className="border-t border-gray-200 my-2" />
            <Row label="50% deposit due today" value={fmt(pkg.deposit_cents)} gold />
            <Row label="Remaining balance" value={fmt(pkg.balance_cents)} />
            <p className="text-xs text-gray-500 mt-4 leading-relaxed">
              Reserve your project with a 50% deposit today. The remaining balance will be due according to the invoice schedule.
            </p>
          </>
        ) : (
          <>
            <Row label="Subtotal" value={fmt(pkg.subtotal_cents)} />
            <Row label="Pay-in-full discount (10%)" value={`−${fmt(pkg.discount_cents)}`} gold />
            <Row label="Discounted subtotal" value={fmt(pkg.discounted_subtotal_cents)} />
            <Row label="HST (13%)" value={fmt(pkg.discounted_hst_cents)} />
            <div className="border-t border-gray-200 my-2" />
            <Row label="Total due" value={fmt(pkg.discounted_total_cents)} bold />
            <p data-testid="savings-callout" className="mt-4 text-center bg-[#c19a6b]/10 text-[#8a6a42] font-bold text-sm py-2.5 tracking-wide">
              You save {fmt(pkg.discount_cents)}
            </p>
          </>
        )}
      </div>

      <button
        data-testid="reserve-btn"
        onClick={onReserve}
        disabled={reserving}
        className="w-full mt-8 h-14 bg-black text-white text-sm uppercase tracking-[0.2em] font-bold btn-lift disabled:opacity-60"
      >
        {reserving ? "Updating your secure invoice..." : changeMode ? "Update My Reservation" : "Reserve Your Project"}
      </button>
      {changeMode && (
        <p className="text-center text-xs text-gray-500 mt-4 tracking-wide" data-testid="change-mode-note">
          Updating replaces your current invoice — the previous one is cancelled automatically, so you'll never be double-billed.
        </p>
      )}
      {pickupDate && (
        <p className="text-center text-xs text-gray-500 mt-4 tracking-wide">
          Reserve your project to secure the next available pickup — {pickupDate}
        </p>
      )}
    </div>
  );
};
